import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaDataFinalizacaoMatricula = (): TabelaColuna => ({
  Chave: 'DataFinalizacaoMatricula',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.dataLocaleString(linha.DataFinalizacaoMatricula)}</span>
  ),
  RenderizarCabecalho: () => (
    <div style={{ width: 90 }}>Data Finalização Matrícula</div>
  )
})
